import React, { useState, useEffect } from "react";
import {
  TableRow,
  TableCell,
  Table,
  TableContainer,
  TableBody,
  Grid,
} from "@material-ui/core";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  DatatablesFooter,
  IconButtonDatatable,
  InputOptionMaster,
  Loading,
  TableHeader,
} from "App/Component/ui";

import { useDatatables } from "App/hooks";
import { getTabData } from "./helpers";
import { useContext } from "react";
import { FormContext } from "../../context/FormContext";
import { isNull, defaultDateDisplay, formatNumber } from "App/utils/helpers";
import { STYLE_DEFAULT_MASTER } from "App/constants";
import { Add } from "@material-ui/icons";
import { sumTotalItem } from "../helpers";

export default function TabItem() {
  const [rows, setRows] = useState([]);
  const { formData } = useContext(FormContext);
  const [kelompokData, setKelompokData] = useState(1);
  const [show, setShow] = useState(0);
  const [loading, setLoading] = useState(false);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "penjualan",
    orderByRow: ["penjualan"],
  });

  useEffect(() => {
    (async () => {
      if (!isNull(formData.tagihan_id)) {
        await setNewData();
      } else {
        setRows([]);
      }
    })();
  }, [formData.tagihan_id]); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async () => {
    setLoading(true);
    const res = await getTabData({
      id: formData.tagihan_id,
      url: "/summary/listItem",
    });
    if (res.state) {
      setRows(res.data);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
    }
  };

  const classes = STYLE_DEFAULT_MASTER();

  return (
    <>
      <Grid
        container
        spacing={2}
        style={{
          marginLeft: "0.4rem",
          marginBottom: "1rem",
        }}>
        <Grid item sm={4}>
          <InputOptionMaster
            name='kelompok_data'
            label='KELOMPOK DATA'
            id='kelompok_data'
            withSearch={false}
            value={kelompokData}
            onChange={(e) => setKelompokData(e.target.value)}
            data={[
              {
                label: "Tanggal Transaksi",
                value: 1,
              },
              {
                label: "Hapus Kelompok Data",
                value: 2,
              },
            ]}
          />
        </Grid>
      </Grid>

      <Loading show={loading} />
      <TableContainer
        className='custom-scrollbar'
        style={{
          background: "#FAFAFA",
        }}>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            classes={classes}
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />

          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <>
                    {parseInt(kelompokData) === 1 ? (
                      <>
                        <TableRow
                          hover
                          tabIndex={-1}
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "transparent" : "#fff",
                          }}>
                          <TableCell component='th' scope='row' padding='none'>
                            <IconButtonDatatable
                              onClick={() =>
                                setShow(index === show ? "" : index)
                              }>
                              <Add
                                style={{
                                  color: "#fff",
                                }}
                              />
                            </IconButtonDatatable>
                          </TableCell>

                          <TableCell
                            align='left'
                            colSpan={headCells.length - 1}>
                            {defaultDateDisplay(row?.tanggaltransaksi, true)}
                          </TableCell>
                        </TableRow>

                        {show === index &&
                          row.barang.map((item, index2) => {
                            return (
                              <TableRowItem
                                item={item}
                                index2={index2}
                                row={row}
                              />
                            );
                          })}
                      </>
                    ) : (
                      row.barang.map((item, index2) => {
                        return (
                          <TableRowItem item={item} index2={index2} row={row} />
                        );
                      })
                    )}
                  </>
                );
              })}

            {rows.length === 0 ? (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            ) : (
              <TableRow>
                <TableCell align='right' colSpan={headCells.length - 1}>
                  Total
                </TableCell>
                <TableCell align='center'>
                  {formatNumber(sumTotalItem(rows, "barang"))}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
}

export const TableRowItem = ({ item, index2, row }) => {
  return (
    <TableRow
      key={index2}
      style={{
        backgroundColor: index2 % 2 === 0 ? "#fff" : "transparent",
      }}>
      <TableCell component='th' scope='row' padding='none' align='center'>
        {index2 + 1}
      </TableCell>
      <TableCell align='left'>
        {defaultDateDisplay(row?.tanggaltransaksi, true)}
      </TableCell>
      <TableCell align='left'>{row?.penjualan}</TableCell>
      <TableCell align='left' width={"10%"}>
        {item?.id_barang}
      </TableCell>
      <TableCell align='left'>{item?.namaBarang}</TableCell>
      <TableCell align='left' width={"5%"}>
        {formatNumber(item?.qty)}
      </TableCell>
      <TableCell align='right' width={"5%"}>
        {formatNumber(item?.hargaCustom)}
      </TableCell>
      <TableCell align='right' width={"5%"}>
        {formatNumber(item.hargaCustom * item.qty)}
      </TableCell>
    </TableRow>
  );
};

export const headCells = [
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "left",
    width: "50px",
  },
  {
    id: "tanggaltransaksi",
    disablePadding: true,
    label: "TANGGAL",
    sort: false,
    align: "left",
  },
  {
    id: "penjualan",
    disablePadding: true,
    label: "ID PENJUALAN",
    sort: false,
    align: "left",
    width: "150px",
  },

  {
    id: "id_barang",
    disablePadding: true,
    label: "ID BARANG",
    sort: false,
    align: "left",
  },
  {
    id: "namaBarang",
    disablePadding: true,
    label: "NAMA",
    sort: false,
    align: "left",
  },
  {
    id: "qty",
    disablePadding: true,
    label: "QTY",
    sort: false,
    align: "left",
  },
  {
    id: "hargaCustom",
    disablePadding: true,
    label: "HARGA",
    sort: false,
    align: "left",
  },
  {
    id: "total",
    disablePadding: true,
    label: "TOTAL",
    sort: false,
    align: "left",
  },
];
